import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock",
  "use": "lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"lock\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M20 20c0 .6-.4 1-1 1H5a1 1 0 01-1-1v-7c0-.6.5-1 1-1h14c.6 0 1 .4 1 1v7zM8 7a4 4 0 018 0v3H8V7zm11 3h-1V7A6 6 0 006 7v3H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol